<div class="list-page kapea" style="max-width: 1500px">
  <app-asiakas-otsikko otsikko="Keskeneräiset työt" paluuUrl="/asiakkaat" [asiakas]="asiakasObservable | async"></app-asiakas-otsikko>

  @if (tyojonolatauksetKeskenCountObservable | async; as lataukset) {
    <div>
      @if (lataukset.length) {
        <div>
          <p class="dark-gray-text" style="margin: 3em 0">Seuraavat työt ovat kesken:</p>
          <ul>
            @for (lataus of lataukset; track lataus) {
              <li>
                {{ lataus }}
              </li>
            }
          </ul>
        </div>
      } @else {
        <p class="dark-gray-text" style="margin: 3em 0">Ei keskeneräisiä töitä</p>
      }
    </div>
  }
</div>
